module.exports = __webpack_public_path__ + "a64f581b64fe9d3edeb5fe9402943b2b.svg";